import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export const auth = {
  login:    (email, password) => http.post("/auth/login", { email, password }).then(r => r.data),
  logout:   () => http.post("/auth/logout").then(r => r.data),
  me:       () => http.get("/auth/me").then(r => r.data),
  listAdmins:  () => http.get("/auth/admins").then(r => r.data),
  createAdmin: (payload) => http.post("/auth/admins", payload).then(r => r.data),
  updateAdmin: (id, payload) => http.put(`/auth/admins/${id}`, payload).then(r => r.data),
  deleteAdmin: (id) => http.delete(`/auth/admins/${id}`).then(r => r.data),
  changePassword: (current_password, new_password) =>
    http.post("/auth/change-password", { current_password, new_password }).then(r => r.data),
  // v35 — Tech (Armada) auth
  techLogin:      (username, password) => http.post("/auth/tech-login", { username, password }).then(r => r.data),
  techMe:         () => http.get("/auth/tech-me").then(r => r.data),
  techLogout:     () => http.post("/auth/tech-logout").then(r => r.data),
  setTechPassword: (techId, payload) => http.put(`/auth/technicians/${techId}/set-password`, payload).then(r => r.data),
};

export const api = {
  stats:        () => http.get("/dashboard/stats").then(r => r.data),
  schedule:     (day) => http.get("/schedule/today", { params: { day } }).then(r => r.data),

  listTechs:    () => http.get("/technicians").then(r => r.data),
  adminTechLocations: () => http.get("/admin/tech-locations").then(r => r.data),
  routingStatus: (checkOrs = false) => http.get(`/admin/routing/status?check_ors=${checkOrs}`).then(r => r.data),
  routingEnginesPut: (patch) => http.put("/admin/routing/engines", patch).then(r => r.data),
  techDevices: (techId) => http.get(`/admin/tech/${techId}/devices`).then(r => r.data),
  revokeTechDevice: (techId, deviceId) => http.delete(`/admin/tech/${techId}/devices/${encodeURIComponent(deviceId)}`).then(r => r.data),
  adminGpsPing: (techId) => http.post(`/admin/tech/${techId}/gps-ping`).then(r => r.data),
  createTech:   (t) => http.post("/technicians", t).then(r => r.data),
  updateTech:   (id, t) => http.put(`/technicians/${id}`, t).then(r => r.data),
  deleteTech:   (id) => http.delete(`/technicians/${id}`).then(r => r.data),
  seedTechs:    () => http.post("/technicians/seed").then(r => r.data),
  linkCal:      (id, calendarId) => http.post(`/technicians/${id}/calendar`, null, {params: {calendar_id: calendarId}}).then(r => r.data),
  // v85.34 — Resume WO Harian: trigger manual (per-tech atau all)
  sendTechDailyResume: ({ tech_id, date, dry_run } = {}) => http.post(
    "/technicians/send-daily-resume",
    null,
    { params: { ...(tech_id ? { tech_id } : {}), ...(date ? { date } : {}), ...(dry_run ? { dry_run } : {}) } }
  ).then(r => r.data),

  listOrders:   (params) => http.get("/work-orders", { params }).then(r => r.data),
  searchOrders: (q) => http.get("/work-orders/search", { params: { q } }).then(r => r.data),
  countOrders:  (params) => http.get("/work-orders/count", { params }).then(r => r.data),
  createOrder:  (o) => http.post("/work-orders", o).then(r => r.data),
  updateOrder:  (id, o) => http.put(`/work-orders/${id}`, o).then(r => r.data),
  deleteOrder:  (id) => http.delete(`/work-orders/${id}`).then(r => r.data),
  reassign:     (id) => http.post(`/work-orders/${id}/reassign`).then(r => r.data),
  updateStatus: (id, status) => http.patch(`/work-orders/${id}/status`, null, { params: { status }}).then(r => r.data),
  completeOrder: (id, actual_duration_minutes) => http.post(`/work-orders/${id}/complete`, { actual_duration_minutes }).then(r => r.data),

  estimate:     (service_type, quantity) => http.get("/estimator/preview", { params: { service_type, quantity }}).then(r => r.data),
  estimateTable: () => http.get("/estimator/table").then(r => r.data),
  // v84.68 — Estimator v2 (job-category granular)
  estimateTableV2:    () => http.get("/estimator/v2/table").then(r => r.data),
  estimatorAnalyzeV2: (days = 15) => http.post("/estimator/v2/analyze", null, { params: { days }}).then(r => r.data),
  // v85.42 — Duration Fixed (manual override admin, prioritas 0)
  durationFixedGet:   () => http.get("/duration-fixed").then(r => r.data),
  durationFixedSave:  (payload) => http.post("/duration-fixed", payload).then(r => r.data),
  estimateLookupV2:   (job_category, quantity) => http.get("/estimator/v2/lookup", { params: { job_category, quantity }}).then(r => r.data),

  listConvos:   (params={}) => http.get("/conversations", { params }).then(r => r.data),
  searchConvos: (q) => http.get("/conversations/search", { params: { q } }).then(r => r.data),
  markConvoResolved: (cid) => http.post(`/conversations/${cid}/mark-resolved`).then(r => r.data),
  convoMsgs:    (id, params) => http.get(`/conversations/${id}/messages`, { params }).then(r => r.data),
  newConvo:     (phone, name) => http.post("/conversations/new", null, { params: { customer_phone: phone, customer_name: name }}).then(r => r.data),
  simSend:      (payload) => http.post("/simulator/send", payload).then(r => r.data),
  simSendContact: (conversation_id, contact_name, contact_phone) =>
    http.post("/simulator/send-contact", { conversation_id, contact_name, contact_phone })
        .then(r => r.data),
  manualReply:  (id, text) => http.post(`/conversations/${id}/reply`, { text }).then(r => r.data),
  toggleConvoAI: (id, paused) => http.post(`/conversations/${id}/toggle-ai`, null, { params: { paused }}).then(r => r.data),
  dismissDraft: (id) => http.post(`/conversations/${id}/dismiss-draft`).then(r => r.data),
  sendMedia: (id, file, caption) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post(`/conversations/${id}/send-media`, fd, {
      params: { caption: caption || "" },
      headers: { "Content-Type": "multipart/form-data" },
    }).then(r => r.data);
  },
  markConvoRead: (id) => http.post(`/conversations/${id}/mark-read`).then(r => r.data),

  aiStatus:     () => http.get("/ai/status").then(r => r.data),
  aiToggle:     (payload) => {
    // v44 — accept {enabled: bool} legacy atau {mode: "manual"|"semi"|"away"}
    const params = (payload && typeof payload === "object") ? payload : { enabled: payload };
    return http.post("/ai/toggle", null, { params }).then(r => r.data);
  },
  notifications: () => http.get("/notifications/unread").then(r => r.data),

  // v84.74 — Manual reminder entry (halaman Customer)
  reminderManualCreate: (payload) => http.post("/customer/reminder-manual", payload).then(r => r.data),
  reminderManualList:   (limit=200) => http.get(`/customer/reminder-manual/list?limit=${limit}`).then(r => r.data),
  reminderPendingCount: () => http.get("/customer/reminder-pending-count").then(r => r.data),
  // v85.18 — Reminder analytics (chart widget di halaman Customer)
  reminderAnalytics:    (months=6) => http.get(`/customer/reminder-analytics?months=${months}`).then(r => r.data),
  // v85.24 — Master toggle pesan otomatis (followup / reminder / force_qo)
  autoMsgSettingsGet:   () => http.get("/customer/auto-message-settings").then(r => r.data),
  autoMsgSettingsPut:   (patch) => http.put("/customer/auto-message-settings", patch).then(r => r.data),
  pushStats:            () => http.get("/admin/push-stats").then(r => r.data),
  // v85.25 — AI WO Arranger (config + manual run + logs)
  aiArrangerConfigGet:  () => http.get("/ai-arranger/config").then(r => r.data),
  aiArrangerConfigPut:  (patch) => http.put("/ai-arranger/config", patch).then(r => r.data),
  aiArrangerRunNow:     (date_from, date_to) =>
    http.post(`/ai-arranger/run-now?date_from=${date_from}&date_to=${date_to || date_from}`).then(r => r.data),
  aiArrangerRunStatus:  (job_id) => http.get(`/ai-arranger/run-status/${job_id}`).then(r => r.data),
  aiArrangerLogs:       (limit=20) => http.get(`/ai-arranger/logs?limit=${limit}`).then(r => r.data),
  // v85.26 — Cleanup stale SCHEDULED WOs → DONE (manual trigger admin)
  cleanupStaleScheduled: ({ days_threshold=3, dry_run=false } = {}) =>
    http.post(
      `/work-orders/cleanup-stale-scheduled?days_threshold=${days_threshold}&dry_run=${dry_run}`
    ).then(r => r.data),
  // v85.25 — Backfill lat/lng WO lama (batching, hemat quota geocoding)
  backfillWoCoords:     ({ dry_run=false, limit=40, retry_maps_link=true } = {}) =>
    http.post(
      `/work-orders/backfill-coords?dry_run=${dry_run}&limit=${limit}&retry_maps_link=${retry_maps_link}`
    ).then(r => r.data),
  // v85.30 — Backfill "Ket: jam HH.MM" dari pesan konfirmasi untuk WO QO lama
  backfillQoTimeHint:   ({ date_from, date_to, dry_run=true } = {}) =>
    http.post(
      `/work-orders/backfill-qo-time-hint?date_from=${date_from}&date_to=${date_to}&dry_run=${dry_run}`
    ).then(r => r.data),
  // v84.108 — Quick Order Personal Link
  orderTokenGen:    (phone, name="") => http.post(`/customer/order-token/generate?phone=${encodeURIComponent(phone)}&name=${encodeURIComponent(name)}`).then(r => r.data),
  orderTokenLookup: (phone) => http.get(`/customer/order-token/lookup?phone=${encodeURIComponent(phone)}`).then(r => r.data),

  // v84.81 — Quick Replies (balas cepat admin)
  listQuickReplies:   () => http.get("/quick-replies").then(r => r.data),
  createQuickReply:   (text) => http.post("/quick-replies", { text }).then(r => r.data),
  useQuickReply:      (id) => http.post(`/quick-replies/${id}/use`).then(r => r.data),
  deleteQuickReply:   (id) => http.delete(`/quick-replies/${id}`).then(r => r.data),

  // v84.93 — Kasbon Teknisi (Task A)
  listKasbon:   (date) => http.get(`/kasbon?date=${date}`).then(r => r.data),
  upsertKasbon: (payload) => http.post("/kasbon", payload).then(r => r.data),
  listCategories: () => http.get("/categories").then(r => r.data),
  addCategory:  (key) => http.post("/categories", { key }).then(r => r.data),
  deleteCategory: (key) => http.delete(`/categories/${key}`).then(r => r.data),

  waStatus:     () => http.get("/whatsapp/status").then(r => r.data),
  waSettings:   () => http.get("/whatsapp/settings").then(r => r.data),
  waSave:       (s) => http.post("/whatsapp/settings", s).then(r => r.data),
  waForwardRoutes:     () => http.get("/whatsapp/forward-routes").then(r => r.data),
  waForwardRoutesSave: (routes) => http.put("/whatsapp/forward-routes", { routes }).then(r => r.data),

  googleStatus: () => http.get("/google/status").then(r => r.data),
  googleSaveCreds: (creds) => http.post("/google/credentials", creds).then(r => r.data),
  googleLogin:  () => http.get("/google/login").then(r => r.data),
  googleCalendars: () => http.get("/google/calendars").then(r => r.data),
  googleDisconnect: () => http.post("/google/disconnect").then(r => r.data),
  googlePullSync: (force=false) => http.post(`/google/pull-sync${force ? "?force=true" : ""}`).then(r => r.data),
  googleSyncStatus: (hours=24) => http.get(`/google/sync-status?hours=${hours}`).then(r => r.data),
  gcalSyncEventsCleanup: (days=30, dryRun=false) => http.post(`/gcal-sync-events/cleanup?days=${days}&dry_run=${dryRun}`).then(r => r.data),
  // v72/v74 — customer history
  customerHistoryGet: (phone) => http.get(`/customer-history/${encodeURIComponent(phone)}`).then(r => r.data),
  customerHistoryList: (q="", limit=50) => http.get(`/customer-history?q=${encodeURIComponent(q)}&limit=${limit}`).then(r => r.data),
  googleLearn:  () => http.post("/google/learn-durations").then(r => r.data),
  billingRecap: (params={}) => http.get("/billing-recap", { params }).then(r => r.data),
  billingDetail: (id) => http.get(`/billing/${id}`).then(r => r.data),
  billingEdit: (id, body) => http.put(`/billing/${id}`, body).then(r => r.data),
  billingDelete: (id) => http.delete(`/billing/${id}`).then(r => r.data),
  ensureBillingLinks: undefined,   // removed — billing feature dihapus (v21)
  refreshOrderIdLines: (limit=30) => http.post(`/work-orders/refresh-order-id-lines?limit=${limit}`).then(r => r.data),
  backfillGcalNotes: (limit=30) => http.post(`/work-orders/backfill-gcal-notes?limit=${limit}`).then(r => r.data),
  dedupWoByGcalEvent: (dry_run=false) => http.post(`/work-orders/dedup-by-gcal-event?dry_run=${dry_run}`).then(r => r.data),

  icalImport:   (file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post("/calendar/import-ics", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 300_000,       // 5 menit — file .zip bisa besar
      onUploadProgress: onProgress,
    }).then(r => r.data);
  },
  icalStats:    () => http.get("/calendar/import-stats").then(r => r.data),
  icalLearn:    () => http.post("/calendar/learn-from-ics").then(r => r.data),
  icalDurationStats: () => http.get("/calendar/duration-stats").then(r => r.data),

  // v84.46 — Import Customer History (multi-file .ics/.zip/.rar)
  customerHistoryImport: (files, onProgress) => {
    const fd = new FormData();
    for (const f of files) fd.append("files", f);
    return http.post("/admin/import-customer-history", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 600_000,       // 10 menit — banyak file bisa besar
      onUploadProgress: onProgress,
    }).then(r => r.data);
  },

  geocode:      (address) => http.post("/geocode", null, { params: { address }}).then(r => r.data),

  listZones:    () => http.get("/zones").then(r => r.data),
  refreshZones: () => http.post("/zones/refresh").then(r => r.data),
  autoMapZones: () => http.post("/technicians/auto-map-zones").then(r => r.data),

  // Tarif & Harga (Pricing Catalog) — endpoint tetap di prefix /billing untuk
  // menghindari migrasi index & backward-compat. AI juga pakai path yg sama.
  listMasterData: (category) => http.get("/billing/master-data", { params: category ? { category } : {}}).then(r => r.data),
  createMasterItem: (payload) => http.post("/billing/master-data", payload).then(r => r.data),
  updateMasterItem: (id, payload) => http.put(`/billing/master-data/${id}`, payload).then(r => r.data),
  deleteMasterItem: (id) => http.delete(`/billing/master-data/${id}`).then(r => r.data),
  listWarranty:   () => http.get("/billing/warranty-rules").then(r => r.data),
  createWarranty: (payload) => http.post("/billing/warranty-rules", payload).then(r => r.data),

  // Dynamic AI Rules
  listAIRules:  () => http.get("/ai-rules").then(r => r.data),
  createAIRule: (payload) => http.post("/ai-rules", payload).then(r => r.data),
  updateAIRule: (id, payload) => http.put(`/ai-rules/${id}`, payload).then(r => r.data),
  deleteAIRule: (id) => http.delete(`/ai-rules/${id}`).then(r => r.data),

  // v35 — Tech Rekap Kerja & Public Invoice
  techRekap:    (from, to) => http.get("/tech/rekap", { params: { from, to } }).then(r => r.data),
  publicInvoice: (eventId) => http.get(`/public/invoice/${eventId}`).then(r => r.data),

  // v40 — Send template Meta via chat
  sendTemplate: (cid, payload) => http.post(`/conversations/${cid}/send-template`, payload).then(r => r.data),

  // v38 — Commission CRUD
  listCommissions:   () => http.get("/commissions").then(r => r.data),
  createCommission:  (payload) => http.post("/commissions", payload).then(r => r.data),
  updateCommission:  (id, payload) => http.put(`/commissions/${id}`, payload).then(r => r.data),
  deleteCommission:  (id) => http.delete(`/commissions/${id}`).then(r => r.data),
  reseedCommissions: () => http.post("/commissions/reseed").then(r => r.data),

  // v82 — Personnel (Data Teknisi individu), Armada Assignment, Commission Dashboard
  listPersonnel:      () => http.get("/personnel").then(r => r.data),
  // v84.70 — Cuti karyawan + public holidays
  leavesSummary:      () => http.get("/leaves/summary").then(r => r.data),
  rolloverAnniversary:() => http.post("/leaves/anniversary-rollover").then(r => r.data),
  updateLeaveInfo:    (pid, payload) => http.put(`/personnel/${pid}/leave-info`, payload).then(r => r.data),
  deductLeave:        (payload) => http.post("/leaves/deduct", payload).then(r => r.data),
  listHolidays:       () => http.get("/public-holidays").then(r => r.data),
  addHoliday:         (date, label) => http.post("/public-holidays", { date, label }).then(r => r.data),
  deleteHoliday:      (date) => http.delete(`/public-holidays/${date}`).then(r => r.data),
  createPersonnel:    (payload) => http.post("/personnel", payload).then(r => r.data),
  updatePersonnel:    (id, payload) => http.put(`/personnel/${id}`, payload).then(r => r.data),
  deletePersonnel:    (id) => http.delete(`/personnel/${id}`).then(r => r.data),
  listArmadaAssignments: (params={}) => http.get("/armada-assignments", { params }).then(r => r.data),
  upsertArmadaAssignment: (payload) => http.post("/armada-assignments", payload).then(r => r.data),
  deleteArmadaAssignment: (id) => http.delete(`/armada-assignments/${id}`).then(r => r.data),
  commissionDashboard: (params={}) => http.get("/commission-dashboard", { params }).then(r => r.data),
  // v84.94 — Payroll (Task B)
  payrollSettings:      () => http.get("/payroll/settings").then(r => r.data),
  updatePayrollSettings:(payload) => http.put("/payroll/settings", payload).then(r => r.data),
  payrollCycles:        (year, month) => http.get(`/payroll/cycles?year=${year}&month=${month}`).then(r => r.data),
  payrollCalc:          (period_key) => http.get(`/payroll/calc?period_key=${period_key}`).then(r => r.data),
  upsertPayrollOverride:(payload) => http.put("/payroll/override", payload).then(r => r.data),
  listPayrollSlips:     (year, month) => http.get("/payroll/slips", { params: { year, month } }).then(r => r.data),
  generatePayrollSlips: (year, month) => http.post("/payroll/slips/generate", { year, month }).then(r => r.data),
  sendAllPayrollSlips:  (year, month) => http.post("/payroll/slips/send", { year, month }).then(r => r.data),
  sendPayrollSlip:      (id) => http.post(`/payroll/slips/${id}/send`).then(r => r.data),
  payrollSlipPdf:       (id) => http.get(`/payroll/slips/${id}/pdf`, { responseType: "blob" }).then(r => r.data),
  // v83 — AI Provider toggle (Claude vs Gemini)
  getAIProvider: () => http.get("/settings/ai-provider").then(r => r.data),
  setAIProvider: (value) => http.put("/settings/ai-provider", { value }).then(r => r.data),
  // v83.2 — Manual Billing (admin)
  createManualBilling: (payload) => http.post("/billing/manual", payload).then(r => r.data),
  // v84.15 — Admin AI Chat (Phase 1 read-only)
  adminAiChat: (session_id, message) =>
    http.post("/admin-ai/chat", { session_id, message }).then(r => r.data),
  downloadAdminReport: (filename) =>
    http.get(`/admin/reports/download/${encodeURIComponent(filename)}`, { responseType: "blob" }).then(r => r.data),
  listWaMessages: () => http.get("/admin/wa-messages").then(r => r.data),
  saveWaMessage:  (key, values) => http.put(`/admin/wa-messages/${key}`, { values }).then(r => r.data),
  resetWaMessage: (key) => http.post(`/admin/wa-messages/${key}/reset`).then(r => r.data),
  armadaRecoveryOrphans: () => http.get("/admin/armada-recovery/orphans").then(r => r.data),
  armadaRecoveryRemap: (old_id, new_id) => http.post("/admin/armada-recovery/remap", { old_id, new_id }).then(r => r.data),
  // v84.170 — Test Webview WhatsApp (Interactive CTA URL Button)
  testWebviewWhatsapp: (payload) =>
    http.post("/admin/test-webview-whatsapp", payload).then(r => r.data),
  // v84.176 — Force Quick Order Mode toggle
  getForceQuickOrder: () => http.get("/admin/force-quick-order").then(r => r.data),
  setForceQuickOrder: (enabled) =>
    http.put("/admin/force-quick-order", { enabled }).then(r => r.data),
  // v84.182 — Update body_text (empty string → reset default)
  updateForceQuickOrderBody: (body_text) =>
    http.put("/admin/force-quick-order", { body_text }).then(r => r.data),
  // v84.184 — Update CTA text / exclusion patterns
  updateForceQuickOrderCta: (cta_text) =>
    http.put("/admin/force-quick-order", { cta_text }).then(r => r.data),
  updateForceQuickOrderPatterns: (thanks_patterns, reminder_casual_replies) =>
    http.put("/admin/force-quick-order",
      { thanks_patterns, reminder_casual_replies }).then(r => r.data),

  // v84.187 — Price List Units (Daftar Harga AC)
  listPriceListUnits: () => http.get("/price-list-units").then(r => r.data),
  createPriceListUnit: (payload) =>
    http.post("/price-list-units", payload).then(r => r.data),
  updatePriceListUnit: (id, payload) =>
    http.put(`/price-list-units/${id}`, payload).then(r => r.data),
  deletePriceListUnit: (id) =>
    http.delete(`/price-list-units/${id}`).then(r => r.data),
  // v84.180 — Force QO diagnostic test-send
  testForceQuickOrderSend: (phone, token_override) =>
    http.post("/admin/force-quick-order/test-send",
      { phone, token_override: token_override || null }).then(r => r.data),
  // v85.1 — Manual send Force QO CTA ke percakapan aktif (dari chat header)
  sendForceQoManual: (conversation_id) =>
    http.post("/admin/force-quick-order/send-manual",
      { conversation_id }).then(r => r.data),
  // v85.2 — ZKTeco ADMS attendance integration
  attendanceSettings: () => http.get("/attendance/settings").then(r => r.data),
  attendanceSaveSettings: (payload) => http.put("/attendance/settings", payload).then(r => r.data),
  attendanceLogs: (limit=10, date=null) => http.get("/attendance/logs", { params: { limit, ...(date ? { date } : {}) } }).then(r => r.data),
  attendanceLogsMatrix: (month) => http.get("/attendance/logs/matrix", { params: { month } }).then(r => r.data),
  // v84.23 — Traccar diagnostic
  traccarDiagnose: (params={}) => http.get("/admin/traccar-diagnose", { params }).then(r => r.data),
  sherlockCfgGet: () => http.get("/settings/sherlock-correction").then(r => r.data),
  sherlockCfgSave: (cfg) => http.put("/settings/sherlock-correction", cfg).then(r => r.data),
  sherlockContext: (woId) => http.get(`/work-orders/${woId}/sherlock-context`).then(r => r.data),
  sherlockManual: (woId, body) => http.post(`/work-orders/${woId}/sherlock-manual`, body).then(r => r.data),
  gpsOfflineAlerts: () => http.get("/admin/gps-offline-alerts").then(r => r.data),
  woDoneNotifications: (since) => http.get("/wo/done-notifications", { params: since ? { since } : {} }).then(r => r.data),
  regenerateGpsToken: (techId) => http.post(`/admin/technicians/${techId}/regenerate-gps-token`).then(r => r.data),
  // v84.29 — Customer lookup untuk autofill address di form Manual WO
  customerLookup: (phone) => http.get("/customer-lookup", { params: { phone } }).then(r => r.data),

  // v84.49 — Break/Cuti register (visibility ketersediaan tenaga kerja harian)
  listBreakLeaves:  (params={}) => http.get("/break-leaves", { params }).then(r => r.data),
  createBreakLeave: (payload) => http.post("/break-leaves", payload).then(r => r.data),
  deleteBreakLeave: (id) => http.delete(`/break-leaves/${id}`).then(r => r.data),

  // v84.55 — Manual repush: kirim ulang maps + billing link ke event GCal yg desc-nya missing
  gcalRepushMissingLinks: (opts={}) => http.post("/gcal/repush-missing-links", null, { params: opts, timeout: 600_000 }).then(r => r.data),

  // v85.44 — Push ulang semua WO di tanggal tertentu ke Google Calendar (upsert)
  pushSyncByDate: (date) => http.post("/calendar/push-sync-by-date", null, {
    params: { date }, timeout: 600_000,
  }).then(r => r.data),

  // v85.45 — Cancel alerts: WO yg cancel_note belum dibaca admin
  woCancelAlerts: () => http.get("/wo/cancel-alerts").then(r => r.data),
  woMarkCancelNoteRead: (id) => http.patch(`/wo/${id}/cancel-note-read`).then(r => r.data),

  // v84.58 — Export Excel: download .xlsx dgn 2 tab (Rekap Penagihan + Komisi Teknisi)
  exportBillingRecapExcel: (params={}) => http.get("/billing-recap/export-excel", {
    params, responseType: "blob", timeout: 120_000,
  }).then(r => r.data),
};
